<template>
  <v-flex d-flex xs6 sm3 md3 lg2 :title="product.product_title">
    <v-card @click.stop="openModal" style="cursor: pointer" height="100%">
      <div class="soldout-tag" v-if="isOutOfStock">
        <div class="text">{{ $t('Sold Out') }}</div>
      </div>
      <template>
        <v-responsive
          :aspect-ratio="1"
          style="background-position: center; background-size: cover"
        >
          <v-img
            v-if="productImages[0]"
            :src="productImages[0]"
            :lazy-src="`@/assets/img/products/default-photo.png`"
            aspect-ratio="1"
            class="white"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-layout> </template
          ></v-img>
          <v-img
            v-else
            :src="`@/assets/img/products/default-photo.png`"
            aspect-ratio="1"
            class="white"
          >
            <template v-slot:placeholder>
              <v-layout fill-height align-center justify-center ma-0>
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-layout> </template
          ></v-img>
        </v-responsive>
      </template>

      <div
        class="text-xs-center sale-tag caption"
        v-if="discountPercentage > 0 && !['nvbb'].includes(pageProfile.type)"
        style="
          position: absolute;
          right: 5px;
          top: 0;
          background: red;
          color: white;
          padding: 10px;
        "
      >
        {{ $t('Sale') }}
        <br />
        {{ discountPercentage | numberFormat }}%
      </div>

      <v-card-title primary-title class="pt-3">
        <div>
          <div class="caption mb-2 mt-0">{{ product.product_title }}</div>
          <div class="body-1 mb-1" :style="{ color: theme.color }">
            <template v-if="discountPriceRange != priceRange">{{
              discountPriceRange
            }}</template>
            <template v-else>{{ priceRange }}</template>
          </div>
          <div class="caption discount" v-if="discountPriceRange != priceRange">
            {{ priceRange }}
          </div>
          <div class="caption" v-else>&nbsp;</div>
        </div>
      </v-card-title>
    </v-card>
  </v-flex>
</template>

<script>
import { mapGetters } from 'vuex'

import $ from 'jquery'
import config from '@/config'
import axios from 'axios'
import ModalProduct from '@/components/ecommerce/ModalProduct.vue'
import Modal from '@/components/Modal.vue'
import ModalImage from '@/components/ModalImage.vue'
import numeral from 'numeral'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import Nl2br from 'vue-nl2br'
import { Carousel, Slide } from 'vue-carousel'

import vZoom from 'vue-zoom'
import {
  bearhousepackagehasbubble,
  bearhousebubbletea
} from '@/assets/js/BearHouse.js'

export default {
  props: {
    value: Object,
    products: Array
  },
  data() {
    return {
      product: this.value,
      showModal: false,
      showAlert: false,
      showPreview: false,
      currentPreview: null,
      quantity: 1,
      stock: [],
      option: null,
      selectedImage: null,
      loadingProduct: true,
      productbundle: [],
      isImageFail: false
    }
  },
  computed: {
    ...mapGetters({
      cart: 'getCart',
      isWholesale: 'getWholesaleStatus',
      wholesale: 'getWholesale',
      theme: 'getTheme',
      pageProfile: 'getPageProfile'
    }),
    currencySign: function () {
      if (this.product && this.product.currency) {
        return this.getCurrencyByCode(this.product.currency)
      }
      return '฿'
    },
    productImages: function () {
      let images = []
      if (this.product && this.product.product_thumb) {
        if (typeof this.product.product_thumb == Array) {
          images = this.product.product_thumb
        } else {
          images.push(this.product.product_thumb)
        }
      }
      return images
    },
    isOutOfStock: function () {
      return false
    },
    priceRange: function () {
      var min = this.product.product_price
      var max = this.product.product_price
      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPriceRange: function () {
      var min = this.product.product_sale_net
      var max = this.product.product_sale_net

      if (min == max) {
        return this.currencySign + numeral(min).format('0,0.00')
      } else {
        return (
          this.currencySign +
          numeral(min).format('0,0.00') +
          ' - ' +
          this.currencySign +
          numeral(max).format('0,0.00')
        )
      }
    },
    discountPercentage: function () {
      var max =
        ((this.product.product_price - this.product.product_sale_net) /
          this.product.product_price) *
        100
      return max
    },
    totalBundle: function () {
      var vm = this
      var quantity = 0
      if (vm.isWholesale) {
        if (vm.cart) {
          vm.cart.map(function (product) {
            quantity += product.quantity
          })
        }
        return quantity
      }
      var products = vm.cart.filter(function (product) {
        return product.id == vm.product.id
      })
      quantity = 0
      products.map((p) => {
        quantity += p.quantity
      })
      return quantity
    },
    productstock: function () {
      return this.product.productstock ? this.product.productstock : 0
    },
    isBearhouse() {
      return (
        this.pageProfile &&
        this.$store.state.bearhouse.includes(this.pageProfile.pageid)
      )
    },
    bubbletea() {
      return bearhousebubbletea(this.products)
    },
    hasBubbleTea() {
      return bearhousepackagehasbubble().includes(this.product.sku)
    }
  },
  components: {
    vZoom,
    ModalProduct,
    Modal,
    ModalImage,
    VueperSlides,
    VueperSlide,
    Nl2br,
    Carousel,
    Slide
  },
  watch: {
    value() {
      let vm = this
      this.product = this.value
      if (this.productImages.length > 0) {
        this.selectedImage = this.productImages[0]
      }

      vm.setOption()
    },
    showModal(newVal) {
      if (newVal) {
        $('body').addClass('modal-open')
      } else {
        $('body').removeClass('modal-open')
      }
    }
  },
  created: function () {},
  mounted: function () {
    let vm = this
    if (vm.productImages.length > 0) {
      vm.selectedImage = vm.productImages[0]
    }
    vm.setOption()
    vm.loadingProduct = false
  },
  methods: {
    getProductBundle: function (callback) {
      let vm = this
      let url =
        config.getConfig('serverUrl') +
        'productbundle?productid=' +
        vm.product.id
      axios.get(url).then((response) => {
        response = response.data
        if (response.responsecode == 200) {
          vm.productbundle = response.productbundlelist
          callback()
        } else {
          callback()
        }
      })
    },
    onPreviewImgError: function () {
      this.isImageFail = true
    },
    setOption: function () {
      let vm = this
      if (
        vm.product &&
        vm.product.productstock &&
        vm.product.productstock.length > 0
      ) {
        vm.option = null
        $.each(vm.productstock, function (index, val) {
          if (parseInt(val[2]) > 0) {
            vm.option = val
            return false
          }
        })
      } else {
        vm.option = null
      }
    },
    openModal: function () {
      this.$emit('selectProduct')
    },
    close: function () {
      let vm = this
      if (window.history.length == 0) {
        vm.showModal = false
      } else {
        window.history.back()
      }
    },
    addCount: function () {
      if (!this.option || this.option == null) {
        return false
      }
      if (this.quantity < this.option[2]) {
        this.quantity++
      }
    },
    removeCount: function () {
      if (this.quantity > 1) {
        this.quantity--
      }
    }
  }
}
</script>

<style scoped></style>
